import React, { useState } from "react";
import "./App.scss";
import ExternalFiles from "./shared/ExternalJS&FileHandler";
import Main from "./components/Main/Main";
import NetworkErrorHandler from "./shared/NetworkErrorHandler";
//import NetOffline from "./components/Error/NetOffline";

function App() {
  const [config, setConfig] = useState(window.global?.config);
  // const [netOffline, setNetOffline] = useState(null);

  const getFilesSuccesFull = (configuration) => {
    setConfig(configuration);
  };


  return (
    // network  
    <>
      
        <NetworkErrorHandler>
          {config && <Main/>}
          <ExternalFiles
            path={`${window.location.origin}`}
            getFilesSuccesFull={getFilesSuccesFull}
          />
        </NetworkErrorHandler>
      
    </>
  );
}

export default App;
